import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar-buyer',
  templateUrl: './progress-bar-buyer.component.html',
  styleUrls: ['./progress-bar-buyer.component.scss']
})
export class ProgressBarBuyerComponent implements OnInit {
  @Input() active?: any;
  steps = [
      'Αποδοχή Αίτησης',
      'Παρακολούθηση Υποβληθείσας Αίτησης',
  ];
  constructor() {}

  ngOnInit(): void {
      if (!this.active) {
          this.active = 4;
      }
  }
}
